module.exports = __webpack_public_path__ + "static/media/savest-houseicon.25cd50d1.svg";